import type { NodeId } from "../../types";

export class ConnectionInvocationIdFactory {
  static create(): string {
    return `cinv_${globalThis.crypto.randomUUID()}`;
  }

  static createForTest(runId: string, connectionNodeId: NodeId, sequence: number): string {
    return `cinv_${runId}_${connectionNodeId}_${sequence}`;
  }
}
